module.exports = __webpack_public_path__ + "img/sms-svgrepo-com.0616a9e8.svg";